import type { Extensions } from '@tiptap/core';
import StarterKit from '@tiptap/starter-kit';
import Link from '@tiptap/extension-link';
import Table from '@tiptap/extension-table';
import TableRow from '@tiptap/extension-table-row';
import TableCell from '@tiptap/extension-table-cell';
import TableHeader from '@tiptap/extension-table-header';
import Placeholder from '@tiptap/extension-placeholder';
import { Markdown } from 'tiptap-markdown';

import { FigureImage } from './figureImage';
import { Callout } from './callout';
import { DialectBlock } from './dialectBlock';

/**
 * The body editor's extension set.
 *
 * Lifted out of the component so a test can round-trip markdown through
 * EXACTLY what the editor runs. The alternative — a test that assembles its own
 * list — verifies a copy, and the failure this guards against is precisely the
 * editor's list falling behind the dialect.
 */
export const bodyEditorExtensions = (placeholder: string): Extensions => [
  StarterKit.configure({ heading: { levels: [2, 3] } }),
  Link.configure({ openOnClick: false }),
  FigureImage.configure({ allowBase64: true }),
  Table.configure({ resizable: false }),
  TableRow,
  TableCell,
  TableHeader,
  Callout,
  DialectBlock,
  Placeholder.configure({ placeholder }),
  Markdown.configure({ html: true, linkify: true }),
];
